export const BC_CART_COOKIE_NAME = 'bc_cartId';
export const BC_CUSTOMER_TOKEN_NAME = 'mecBcCustomerToken';
export const BC_CHECKOUT_LOCALE_COOKIE_NAME = 'mecCheckoutLocale';
export const BC_CHECKOUT_SESSION_COOKIE_NAME = 'mecSessionId';
export const FINDIFY_CHECKOUT_NAME = 'mecFindify';
export const ALGOLIA_CHECKOUT_USER_TOKEN_NAME = 'mecAlgoliaUserToken';
export const ALGOLIA_CHECKOUT_QUERY_ID_NAME = 'algoliaQueryID';
export const SPU_STORE_NAME = 'mecSPUStoreName';
// ED-555 add-to-cart source map (see utils/cart/atcSource.ts). The storefront writes
// the host-only cookie; /[locale]/checkout re-issues it on `mecDomain` under the
// checkout name (filtered to the cart), which mec-checkout-js reads. Distinct names
// so the storefront never reads back the older `.mec.ca` copy on www.mec.ca.
export const ATC_SOURCE_COOKIE_NAME = 'mecAtcSource';
export const ATC_SOURCE_CHECKOUT_COOKIE_NAME = 'mecAtcSourceCheckout';
// Matches the cart cookie lifetime (`cartCookieMaxAge`).
export const ATC_SOURCE_COOKIE_MAX_AGE_DAYS = 30;
// Budget for the encoded `name=value` pair, under browsers' ~4096-byte per-cookie
// limit with room to spare; past it a write is silently rejected.
export const ATC_SOURCE_COOKIE_MAX_BYTES = 3800;
export const SPU_MESSAGE = 'mecSPUMessage';
export const GIFT_CARD_ID = process.env.NEXT_PUBLIC_GIFTCARD_API_URL?.endsWith(
  '/prod'
)
  ? 45198
  : process.env.NEXT_PUBLIC_GIFTCARD_API_URL?.endsWith('/uat')
  ? 45173
  : 83285;

export const ORDER_REFERENCE_TOKEN_NAME = 'orderReferenceToken';

export const CART_COLOUR = 'cart.colour';
export const CART_SIZE = 'cart.size';
export const CART_GIFTCARD_COLOUR = 'cart.giftcard.card.design';
export const CHECKOUT_STATUS = 'checkout_status';
export const WATCHED_PDP_VIDEOS = 'watchedPdpVideos';
export const CHECKOUT_STATUSES = {
  NEW_MEMBER: 'new_member',
  MEMBER_LOGGED_IN: 'member_logged_in',
  MEMBER_LOGGED_OUT: 'member_logged_out',
  GUEST: 'guest',
} as const;

export const PTT_VIDEOS_COOKIE_NAME = 'watchedPTTVideos';

export const DEFAULT_SHIPPING_ADDRESS = {
  first_name: 'Guest',
  last_name: 'User',
  address1: '887 Great Northern Wy',
  city: 'Vancouver',
  state_or_province: 'British Columbia',
  postal_code: 'V5T 4T5',
  country_code: 'CA',
  email: 'guest@example.com',
  phone: '6049999999',
};
